const Md = () => {
  return (
    <div className="absolute h-[70vh] w-[80vw] top-[2.6vw] left-[15.8vw] z-10 flex flex-col items-center justify-center">
      <div className="wip text-[40vw] inter text-[#828D72] leading-none">
        WIP
      </div>
      <div className="relative bottom-[9.23vw] left-[3.1vw] text-[3.4vw] inter mix-blend-difference text-[#828D72] px-4">
        WORK IN PROGRESS
      </div>
    </div>
  );
};

export default Md;
